import type { IObjectiveFinancialSecurity } from './ObjectiveFinancialSecurity.interface';
import { LevelOption } from '../global/LevelOption.enum';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectiveFinancialSecurity implements IObjectiveFinancialSecurity {
  levelOfFinancialExperience: LevelOption;
  concernedAboutMovementsInInterestRates: LevelOption;
  concernedAboutMovementsInInterestRatesComments: string;
  importantFlexibilityOfLoan: LevelOption;
  importantFlexibilityOfLoanComments: string;
  concernedAboutYourCurrentJobSecurity: LevelOption;
  concernedAboutYourCurrentJobSecurityComments: string;
  concernedAboutNegativePropertyValue: LevelOption;
  concernedAboutNegativePropertyValueComments: string;
  haveAnEmergencyFund: YesNoOption;
  ableToMaintainYourCommitmentsAndLifestyle: YesNoOption;
  haveAdequateInsurance: YesNoOption;
  haveAdequateInsuranceComments: string;
  haveWill: YesNoOption;
  awareOfAnyCircumstances: YesNoOption;
  awareOfAnyCircumstancesComments: string;

  static build = (data: IObjectiveFinancialSecurity) => new ObjectiveFinancialSecurity(data);
  static blank = () => new ObjectiveFinancialSecurity();

  /**
   * Constructor
   * @param {IObjectiveFinancialSecurity} data
   */
  constructor(data?: IObjectiveFinancialSecurity) {
    this.levelOfFinancialExperience = LevelOption.of(
      data?.levelOfFinancialExperience?.name || data?.levelOfFinancialExperience?.toString()
    );
    this.concernedAboutMovementsInInterestRates = LevelOption.of(
      data?.concernedAboutMovementsInInterestRates?.name ||
        data?.concernedAboutMovementsInInterestRates?.toString()
    );
    this.concernedAboutMovementsInInterestRatesComments =
      data?.concernedAboutMovementsInInterestRatesComments || '';
    this.importantFlexibilityOfLoan = LevelOption.of(
      data?.importantFlexibilityOfLoan?.name || data?.importantFlexibilityOfLoan?.toString()
    );
    this.importantFlexibilityOfLoanComments = data?.importantFlexibilityOfLoanComments || '';
    this.concernedAboutYourCurrentJobSecurity = LevelOption.of(
      data?.concernedAboutYourCurrentJobSecurity?.name ||
        data?.concernedAboutYourCurrentJobSecurity?.toString()
    );
    this.concernedAboutYourCurrentJobSecurityComments =
      data?.concernedAboutYourCurrentJobSecurityComments || '';
    this.concernedAboutNegativePropertyValue = LevelOption.of(
      data?.concernedAboutNegativePropertyValue?.name ||
        data?.concernedAboutNegativePropertyValue?.toString()
    );
    this.concernedAboutNegativePropertyValueComments =
      data?.concernedAboutNegativePropertyValueComments || '';
    this.haveAnEmergencyFund = YesNoOption.of(
      data?.haveAnEmergencyFund?.name || data?.haveAnEmergencyFund?.toString()
    );
    this.ableToMaintainYourCommitmentsAndLifestyle = YesNoOption.of(
      data?.ableToMaintainYourCommitmentsAndLifestyle?.name ||
        data?.ableToMaintainYourCommitmentsAndLifestyle?.toString()
    );
    this.haveAdequateInsurance = YesNoOption.of(
      data?.haveAdequateInsurance?.name || data?.haveAdequateInsurance?.toString()
    );
    this.haveAdequateInsuranceComments = data?.haveAdequateInsuranceComments || '';
    this.haveWill = YesNoOption.of(data?.haveWill?.name || data?.haveWill?.toString());
    this.awareOfAnyCircumstances = YesNoOption.of(
      data?.awareOfAnyCircumstances?.name || data?.awareOfAnyCircumstances?.toString()
    );
    this.awareOfAnyCircumstancesComments = data?.awareOfAnyCircumstancesComments || '';
  }
}
